import { Model } from '@/models/Model';
export class UserLevel extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'UserLevel';
        this.$endpoint = '/users/{id}/relationships/levels';
        this.$fillable = [];
    }
    user(user) {
        if (typeof user !== 'string') {
            user = user.id || '';
        }
        this.$endpoint = `/users/${user}/relationships/levels`;
        return this;
    }
    userPeek(user) {
        if (typeof user !== 'string') {
            user = user.id || '';
        }
        this.$endpoint = `/users/${user}/relationships/levels/peek`;
        return this;
    }
    setIdAttribute(id) {
        this.$endpoint = `/users/${this.user}/relationships/levels`;
        return id;
    }
    resolvePrimaryKey() {
        return '';
    }
    updateLevel(user, attributes) {
        const endpoint = `/users/${user}/relationships/levels`;
        return this.request('put', endpoint, this.getPayload(attributes));
    }
}
